import { Component } from '@angular/core';

@Component({
  selector: 'body',
  template: `<router-outlet></router-outlet>
  <!-- Google Tag Manager (noscript) -->
    <noscript>
      <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-NL65VH4"
      height="0" width="0" style="display:none;visibility:hidden"
      title="Google Tag Manager"></iframe>
    </noscript>
  <!-- End Google Tag Manager (noscript) -->`
})
export class AppComponent { }



// WEBPACK FOOTER //
// ./src/app/app.component.ts